<template>
  <section>
    <div class="leader">
      <span class="leaderName">{{ leader.name }}</span>

      <span class="leaderSurname">{{ leader.surname }}</span>

      <span class="leaderPosition">{{ leader.position }}</span>

      <img
        :src="leader.picture ? leader.picture : leader.googlePictureURL"
        v-if="leader.picture || leader.googlePictureURL"
      />

      <img src="../../../assets/img/avatar.png" v-else />

      <span class="leaderCouse">{{ leader.course }}</span>
      <br />

      <span class="leaderEmail">{{ leader.email }}</span> <br />

      <span class="leaderCell">{{ leader.cellphone }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: "SelectLeader",
  props: ["leader"]
};
</script>

<style scoped>
.leader {
  background-color: black;
  display: block;
  padding: 2rem;
  border-radius: 0.5rem;
  cursor: pointer;
}
.leader:hover {
  transform: scale(1.05);
  transition: ease-in-out 0.2s;
  box-shadow: 0px 0px 50px 10px rgba(2, 248, 199, 0.86);
}
.leaderName {
  color: #02f8c7;
  font-size: 2.2rem;
  font-weight: 600;
  display: flex;
  width: fit-content;
}
.leaderSurname {
  color: white;
  font-size: 2.2rem;
  font-weight: 600;
  display: flex;
  width: fit-content;
}
.leaderPosition {
  color: white;
  display: flex;
  font-size: 1.3rem;
  margin-top: 1rem;
}
.leader img {
  background-color: white;
  border: solid #02f8c7;
  border-radius: 100%;
  width: 12rem;
  min-width: 10rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4rem;
  margin-bottom: 4rem;
  box-shadow: 0px 0px 50px 10px rgba(2, 248, 199, 0.86);
}
.leaderCouse,
.leaderEmail,
.leaderCell {
  color: white;
  font-size: 1.3rem;
}
@media (max-width: 400px) {
  .leaderName,
  .leaderSurname {
    font-size: 1.8rem;
  }
  .leaderCouse,
  .leaderEmail,
  .leaderCell {
    color: white;
    font-size: 1rem;
  }
}
</style>
